export default {
    data() {
      return {
        defaultImg: require("../assets/default.png") 
      };
    },
    methods: {
        handleImageError(arr, index) {
            arr[index].imgPath = require("../assets/default.png");
            console.log("有图片加载出错了", this.arr[index]);
          },
    },
  };


// WEBPACK FOOTER //
// ./src/mixin/defaultImgMixin.js